import {
  Action,
  Enum,
  PlainObject,
  State,
  formatDateTime,
  formatMoney,
  parseDate
} from "@zyzgroup/core-common";

// 支付方式-枚举
export const XgBillTypeEnum = new Enum({
  WX_MINI: { serverValue: "Y", serverDescription: "微信小程序" },
  ALI_MINI: { serverValue: "B", serverDescription: "支付宝小程序" },
  THIRD: { serverValue: "T", serverDescription: "第三方系统支付" },
  CASH: { serverValue: "C", serverDescription: "现金" },
  COUPON_HOUR: { serverValue: "P", serverDescription: "小时券" },
  SEAMLESS: { serverValue: "N", serverDescription: "无感支付" },
  WX_CREDIT: { serverValue: "?", serverDescription: "微信支付分" },
  ALI_CREDIT: { serverValue: "??", serverDescription: "支付宝芝麻先享" }
});

function reduce(state: State, payload: PlainObject): State {
  state.sn = payload.sn ? String(payload.sn) : ""; // state.sn 数据库中为 number
  state.fee = payload.fee || 0;
  state.type = payload.ctype || "";
  state.time = parseDate(payload.time);
  state.merchsn =
    payload.merchs && payload.merchs[0] ? payload.merchs[0].sn : "";
  // 支付金额
  switch (state.type) {
    case XgBillTypeEnum.COUPON_HOUR:
      // 时长优惠券分钟数
      if (state.fee >= 60) {
        let count = Math.floor(state.fee / 60);
        if (state.fee % 60 !== 0) {
          count += Math.floor(((state.fee % 60) * 100) / 60) / 100;
        }
        state.feeFormatted = count + "小时";
      } else {
        state.feeFormatted = state.fee + "分钟";
      }
      break;
    default:
      // 默认：支付金额
      state.feeFormatted = formatMoney(state.fee, 2);
      break;
  }
  // 支付方式
  state.typeFormatted = XgBillTypeEnum.getName(state.type);
  // 支付时间
  state.timeFormatted = payload.time ? formatDateTime(state.time) : "";
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_BILL":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
